import { Box, Button, Divider, Link, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const WalletBizumButton = styled(Button)(({ theme }) => ({
  color: "#05C0C7",
  borderColor: "#009688",
  borderRadius: theme.shape.borderRadius,
  textTransform: "none",
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  fontWeight: "bold",
  width: "100%",
}));